import { Component, OnInit, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';

import { Observable } from 'rxjs';

import { BaseVraagControlDirective } from '../base/base-vraag-control';
import { Vraag, Antwoord } from '@models/claims';
import { IBaseVraagboomResultaat, Meetgegevens, SchademeldenState, Verzekering, VraagboomAntwoord, VraagboomEmptyResultaat } from '@models/vragenboom';
import { DataService } from '../../../services/data.service';
import { MetenMapper } from '../../../mappers/meten.mapper';
import { AntwoordHelper } from '../../../utils/helpers/antwoord-helper';
import { VraagHelper } from '@services/public_api';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-radiobutton-list',
  templateUrl: './radiobutton-list.component.html',
  styleUrls: ['./radiobutton-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RadiobuttonListComponent extends BaseVraagControlDirective<VraagboomEmptyResultaat> implements OnInit, OnChanges {
  selectedId: string;
  _verzekering: Verzekering;
  _meetgegevens: Meetgegevens;
  resultaten$: Observable<VraagboomAntwoord<IBaseVraagboomResultaat>[]>;
  alleResultaten: VraagboomAntwoord<IBaseVraagboomResultaat>[];

  constructor(_dataService: DataService) {
    super(_dataService);
  }

  ngOnInit() {
    this._verzekering = this._dataService.getVerzekering();
    this._meetgegevens = this._dataService.getMeetgegevens();
    this.resultaten$ = this._dataService.resultaten;
    this.resultaten$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(res => {
        if (res !== undefined && res !== null) {
          this.alleResultaten = res;
        }
      });
  }

  initialize(changes: SimpleChanges): void {
    if (this.antwoordResultaat?.vraag?.id === this.vraag.id && this.antwoordResultaat?.antwoorden?.length === 1) {
      this.selectedId = this.antwoordResultaat.antwoorden[0].id;
    } else {
      this.selectedId = '';
    }
  }

  radiobuttonClicked(id: string): void {
    if (this.vraag == null || this.vraag.antwoorden == null) {
      return;
    }

    this.setAntwoord([].concat(this.vraag.antwoorden.find(a => a.id === id)), new VraagboomEmptyResultaat());
    this.selectedId = id;
  }

  filterAntwoordenOpProduct(antwoorden: Antwoord[]) {
    const antwoordenFiltered: Antwoord[] = [];
    const lineOfBusiness = this._dataService.getOmschrijvingLineOfBusiness();

    antwoorden.forEach((antwoord: Antwoord) => {
      if (AntwoordHelper.antwoordTonenBijLineOfBusiness(antwoord, lineOfBusiness)) {
        antwoordenFiltered.push(antwoord);
      }
    });

    return antwoordenFiltered;
  }

  bepaalVolgnrAntwoord(antwoorden: Antwoord[], antwoord: Antwoord) {
    let response = '';
    // controleren of hetzelfde antwoord vaker voorkomt
    if (antwoorden.findIndex(a => a.titel === antwoord.titel && a.id !== antwoord.id) > -1) {
      let volgnummer = 0;
      antwoorden.forEach((antw: Antwoord) => {
        if (antw.titel === antwoord.titel) {
          volgnummer++;
          if (antw.id === antwoord.id) {
            response = '-' + volgnummer;
          }
        }
      });
    }
    return response;
  }

  geefTitel(antwoord: Antwoord): string {
    return VraagHelper.geefTitel(antwoord.titel, this.alleResultaten);
  }

  geefMeetid(vraag: Vraag, antwoord: Antwoord): string {
    var meetsleutel = this._meetgegevens.sleutel;
    if (this._meetgegevens.status === 'afronden-') {
      meetsleutel = this._dataService.getProductOrOmschrijvingLineOfBusiness().toLowerCase() + '-';
    }
    return 'ipoclick-radio-' + this._dataService.getMeetidPazaProces() + '-' +
      this._meetgegevens.status + meetsleutel +
      MetenMapper.geefVolgnr(this.vraag, this._meetgegevens.reeks) + '_' +
      MetenMapper.formatTitelMetToevoeging(vraag.titel, vraag.titel_toevoeging) + '-' + MetenMapper.format(antwoord.titel) + this.bepaalVolgnrAntwoord(vraag.antwoorden, antwoord);
  }

  validate(vraag: Vraag, antwoorden: Antwoord[], resultaat: VraagboomEmptyResultaat): boolean {
    return true;
  }
}
